import React, { FC } from "react";
import { Controller, UseFormReturn, useWatch } from "react-hook-form";
import { t } from "i18next";

import { OrganizationSettingsFormValues } from "../../OrganizationSettings.types";
import NaceCodeIndustry from "./components/NaceCodeIndustry";

import { Autocomplete, Stack, TextField } from "@components/base";
import { useGetNaceSections } from "@api";
import { useUserStore } from "@store/user";

interface NaceSettings {
  form: UseFormReturn<OrganizationSettingsFormValues>;
}

const NaceSettings: FC<NaceSettings> = ({ form: { control, resetField } }) => {
  const { user } = useUserStore();
  const { naceSections, naceSectionsEnabled } = useGetNaceSections(user);

  const selectedNaceCodeArea = useWatch({
    control: control,
    name: "naceCodeArea",
  });

  return (
    naceSectionsEnabled && (
      <Stack gap={2}>
        <Controller
          control={control}
          name="naceCodeArea"
          render={({
            field,
            fieldState: { error },
          }): React.ReactElement => (
            <Autocomplete
              options={naceSections ?? []}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(a, b) => a.id === b.id}
              value={
                naceSections?.find((s) => s.id === field.value) ?? null
              }
              onChange={(_, option) => {
                resetField("naceCodeIndustry");
                field.onChange(option?.id ?? "");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("organizationSettings.nace.title")}
                  helperText={error?.message}
                  error={Boolean(error)}
                />
              )}
            />
          )}
        />
        {selectedNaceCodeArea && (
          <NaceCodeIndustry control={control} naceSectionId={selectedNaceCodeArea} />
        )}
      </Stack>
    )
  );
};

export default NaceSettings;
